'use es6';

import Immutable from 'immutable';
import ThinListing from 'ecosystem-marketplace-core/records/ThinListing';
import StorefrontFilters from './StorefrontFilters';
const defaults = {
  filters: new StorefrontFilters(),
  items: Immutable.OrderedSet(),
  total: 0
};
class SearchResult extends Immutable.Record(defaults) {
  constructor(json = {}) {
    if (json.filters) {
      json.filters = new StorefrontFilters(json.filters);
    }
    if (json.items) {
      json.items = Immutable.OrderedSet(json.items.map(result => new ThinListing(result)));
    }
    super(json);
  }
}
export default SearchResult;